import { render, staticRenderFns } from "./obatmasuk.vue?vue&type=template&id=f6e4ade4&"
import script from "./obatmasuk.vue?vue&type=script&lang=js&"
export * from "./obatmasuk.vue?vue&type=script&lang=js&"
import style0 from "./obatmasuk.vue?vue&type=style&index=0&id=f6e4ade4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports